import React, { Component } from 'react';
import {connect} from 'react-redux';
import {updateLogCondition} from '../../actions';
import {Api, Time} from '../../util';

import Loading from '../../components/loading';
import {Error} from '../../components/modal';

import FilterContainer from './FilterContainer';
import OrdLogContainer from './OrdLogContainer';
import PageContainer from './PageContainer';


class DownloadLog extends Component {
    constructor(props){
        super(props);
        this.state={
            list: [],
            activePage: 1,
            pageFrom: 0,
            begDate: Time.getPrevMonth(), 
            endDate: Time.getToday(),
            keyword: '',
            ssom: 0,
            seom: 86400000,
            loadingFlag: false,
            showError: false,
            errorContent: ''
        };
        this.handlePageChange = this.handlePageChange.bind(this);

        this.handleOnStartSelect=this.handleOnStartSelect.bind(this);
        this.handleOnEndSelect=this.handleOnEndSelect.bind(this);
        this.handleOnKeywordChange=this.handleOnKeywordChange.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.handleSsomSelect = this.handleSsomSelect.bind(this);
        this.handleSeomSelect = this.handleSeomSelect.bind(this);

        this.handleActivePage = this.handleActivePage.bind(this);


        this.handleHide = this.handleHide.bind(this);
    }

    handleHide(){
        this.setState({
          showError: false
        });
    }

    async searchOrdEs(){
        const {
            pageSize,
            chs
          } = this.props.logCondition;
          const {
            pageFrom,
            begDate,
            endDate,
            keyword,
            ssom,
            seom
          } = this.state;
          let list = [], totalCount = 0, beginIndex = 0;
          if(chs.length > 0){
            try{
                this.setState({loadingFlag: true})
                const ord = await Api.SearchOrdEs({
                    FROM : pageFrom,
                    SIZE: pageSize,
                    EPGID: chs,
                    BEGDATE: begDate,
                    ENDDATE: endDate,
                    SSOM: ssom,
                    SEOM: seom,
                    KEYWORD: keyword
                });
                list = ord.files.hits;
                totalCount = ord.files.total;
                beginIndex = ord.files.from;
            } catch(e) {
                this.setState({
                    showError: true,
                    errorContent: e
                });
            } finally {
                this.props.updateLogCondition({
                    totalCount
                  });
                  this.setState({
                    list,
                    loadingFlag: false
                  });
            }
        }

    }

    async handleOnSubmit(){
        await this.setState({ pageFrom: 0, activePage: 1 });
        await this.searchOrdEs();
    }


    async handlePageChange(pageNumber){
        await this.setState({
          pageFrom: pageNumber
        });
        await this.searchOrdEs();
      }
    handleActivePage(activePage){
        this.setState({activePage});
    }

    handleOnStartSelect(date){
        this.setState({begDate: date});
    }
    handleOnEndSelect(date){
        this.setState({endDate: date});
    }
    handleOnKeywordChange(keyword){
        this.setState({keyword});
    }
    handleSsomSelect(ssom){
        this.setState({ssom});
    }
    handleSeomSelect(seom){
        this.setState({seom});
    }

    render() {
        const {display} = this.props;
        const {
            pageSize,
            chs
        } = this.props.logCondition;
        const {
            list, 
            pageFrom,
            activePage,
            keyword,
            ssom,
            seom,
            loadingFlag,
            showError,
            errorContent
        } = this.state;
        
        const style = {display: display ? 'flex' : 'none'};
        return (
            <div className='content container search' style={style}>
                <FilterContainer
                    keyword={keyword}
                    onStart={ssom}
                    onStop={seom}
                    handleOnStartSelectTime={this.handleSsomSelect}
                    handleOnStopSelectTime={this.handleSeomSelect}
                    handleOnSubmit={this.handleOnSubmit}
                    handleOnStartSelect={this.handleOnStartSelect}
                    handleOnEndSelect={this.handleOnEndSelect}
                    handleOnKeywordChange={this.handleOnKeywordChange}
                />
                <OrdLogContainer list={list} />
                <PageContainer 
                    pageFrom={pageFrom}
                    activePage={activePage}
                    handleActivePage={this.handleActivePage}
                    handlePageChange={this.handlePageChange}
                />
                {loadingFlag && <Loading />}
                {showError && <Error 
                    handleHide={this.handleHide}
                    errorContent={errorContent} />}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
      logCondition: state.logCondition
    }
  };
  
  const mapDispatcherToProps = dispatch => {
    return {
      updateLogCondition: (conditions) => dispatch(updateLogCondition(conditions))
    }
  };
  
  DownloadLog = connect(mapStateToProps, mapDispatcherToProps)(DownloadLog)

export default DownloadLog;


// WEBPACK FOOTER //
// ./src/containers/downloadlog/index.js